import { Tab } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledTab = styled(Tab)({
  '&.MuiTab-root.Mui-selected': {
    color: '#000A19CC',
    fontWeight: '700',
  },
  '&.MuiTab-root.': {
    color: '#6D7484',
  },
})
